<template>
  <div class="editKeywords">
    <div class="editKeywords-title">
      <h4>Keywords</h4>
    </div>
    <div class="editKeywords-controls">
      <pill v-for="keyword in keywords"
        clearable
        :key="keyword"
        @action:delete="() => onDelete(keyword)"
      >
        {{ keyword }}
      </pill>
      <tag-input placeholder="Enter Keyword"
        @action:submit="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import Pill from './Pill.vue'
import TagInput from './TagInput.vue'

export default {
  name: 'EditKeywords',

  components: {
    Pill,
    TagInput
  },

  props: {
    keywords: {
      type: Array,
      default: () => []
    }
  },

  emits: [
    'action:removeKeyword',
    'action:addKeyword'
  ],

  setup (_, { emit }) {
    const onDelete = v => emit('action:removeKeyword', v)
    const onSubmit = v => emit('action:addKeyword', v)

    return {
      onDelete,
      onSubmit
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.editKeywords {
  margin-bottom: 20px;

  &-title {
    padding-bottom: 5px;
    border-bottom: 1px solid $very-light-pink;
    margin-bottom: 10px;

    h4 {
      margin: 0;
      font-family: $defaultFont;
      font-size: 12px;
      font-weight: 400;
      color: $slate-grey;
    }
  }

  &-controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
  }
}
</style>
